import { Table, TableContainer } from '@odin-labs/components';
import { useGetWorkerConnectionsTabQuery } from 'apollo/generated/client-operations';
import { NewHeader } from 'components/header/NewHeader';
import { LoadingError } from 'components/loadingError';
import { WorkerTabProps } from 'containers/worker/types';
import React from 'react';
import { getColumns, WorkerConnectionColumn } from './WorkerConnections.tables';

export function WorkerConnections({
  worker,
  onTabApiChange,
}: WorkerTabProps): React.ReactElement {
  const { workerId } = worker;
  const { data, loading, error, refetch } = useGetWorkerConnectionsTabQuery({
    variables: { workerId },
    fetchPolicy: 'no-cache',
  });
  const connections = data?.getWorker.connections ?? [];
  const columns = React.useMemo<WorkerConnectionColumn[]>(
    () => getColumns(),
    [],
  );

  React.useEffect(
    () => onTabApiChange?.({ refetchData: refetch }),
    [onTabApiChange, refetch],
  );
  if (error) return <LoadingError error={error} />;

  return (
    <TableContainer>
      <NewHeader
        title="Connections"
        size="md"
        actionsProps={{ headerActions: [] }}
      />
      <Table
        loading={loading}
        columns={columns}
        data={connections}
        remote
        disableGlobalFilter
        disableSortBy
      />
    </TableContainer>
  );
}
